
export default function CTASection() {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="p-8 md:p-12 flex flex-col justify-center">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Ready to Dominate Your Market?
              </h2>
              <p className="text-base text-gray-600 mb-8 leading-relaxed">
                Take the first step towards digital excellence. Contact us today for a free
                consultation and discover how we can help your business achieve unprecedented
                growth.
              </p>

              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-4">
                    <i className="ri-phone-line text-orange-600 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-xs text-gray-500">Call Us</div>
                    <a
                      href="tel:+17252756972"
                      className="text-sm font-semibold text-gray-900 hover:text-orange-600"
                    >
                      +1 (725) 275-6972
                    </a>
                  </div>
                </div>

                <div className="flex items-center">
                  <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-4">
                    <i className="ri-mail-line text-orange-600 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-xs text-gray-500">Email Us</div>
                    <a
                      href="mailto:domination@thompsondigital.org"
                      className="text-sm font-semibold text-gray-900 hover:text-orange-600"
                    >
                      domination@thompsondigital.org
                    </a>
                  </div>
                </div>

                <div className="flex items-center">
                  <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-4">
                    <i className="ri-map-pin-line text-orange-600 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-xs text-gray-500">Visit Us</div>
                    <div className="text-sm font-semibold text-gray-900">
                      8025 Tank Loop St, Las Vegas, NV 89166
                    </div>
                  </div>
                </div>
              </div>

              <a
                href="mailto:domination@thompsondigital.org"
                className="inline-block px-8 py-4 bg-orange-600 text-white text-base font-semibold rounded-lg hover:bg-orange-700 transition-all transform hover:scale-105 shadow-lg text-center whitespace-nowrap"
              >
                Schedule Your Free Consultation
              </a>
            </div>

            <div
              className="relative min-h-[400px] lg:min-h-full bg-cover bg-center"
              style={{
                backgroundImage:
                  'url(https://public.readdy.ai/ai/img_res/5ccf4ddbf29adf87622be226f586cc6e.jpg)',
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-r from-orange-600/20 to-orange-800/20"></div>
            </div>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-4 gap-6">
          <div className="bg-white rounded-lg p-6 text-center shadow-md">
            <i className="ri-time-line text-orange-600 text-3xl mb-3"></i>
            <div className="text-2xl font-bold text-gray-900 mb-1">Fast Response</div>
            <div className="text-xs text-gray-600">Within 24 hours</div>
          </div>
          <div className="bg-white rounded-lg p-6 text-center shadow-md">
            <i className="ri-shield-check-line text-orange-600 text-3xl mb-3"></i>
            <div className="text-2xl font-bold text-gray-900 mb-1">Guaranteed</div>
            <div className="text-xs text-gray-600">Quality assurance</div>
          </div>
          <div className="bg-white rounded-lg p-6 text-center shadow-md">
            <i className="ri-award-line text-orange-600 text-3xl mb-3"></i>
            <div className="text-2xl font-bold text-gray-900 mb-1">Certified</div>
            <div className="text-xs text-gray-600">Industry experts</div>
          </div>
          <div className="bg-white rounded-lg p-6 text-center shadow-md">
            <i className="ri-customer-service-2-line text-orange-600 text-3xl mb-3"></i>
            <div className="text-2xl font-bold text-gray-900 mb-1">24/7 Support</div>
            <div className="text-xs text-gray-600">Always available</div>
          </div>
        </div>
      </div>
    </section>
  );
}
